<ion-header mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-title>Compliance Filters</ion-title>
    <ion-buttons slot="start">
      <ion-button mode="ios" fill="clear" (click)="dismiss()" tappable>
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list lines="none" mode="ios">
    <h6 class="ion-text-left ion-padding-start">Status</h6>
    <ion-radio-group mode="md" [(ngModel)]="status">
      <ion-item mode="ios" (click)="status = ''">
        <ion-label>All statuses</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="status = 'compliant'">
        <ion-label>Compliant</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="compliant" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="status = 'non-compliant'">
        <ion-label>Non-compliant</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="non-compliant" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="status = 'pending'">
        <ion-label>Pending</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="pending" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>

    <h6 class="ion-text-left ion-padding-start">Category</h6>
    <ion-radio-group mode="md" [(ngModel)]="category">
      <ion-item mode="ios" (click)="category = ''">
        <ion-label>All categories</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="category = 'Financial Controls'">
        <ion-label>Financial Controls</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="Financial Controls" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="category = 'Data Protection'">
        <ion-label>Data Protection</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="Data Protection" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="category = 'Access Management'">
        <ion-label>Access Management</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="Access Management" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="category = 'Audit Logging'">
        <ion-label>Audit Logging</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="Audit Logging" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="category = 'Enforcement Procedures'">
        <ion-label>Enforcement Procedures</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="Enforcement Procedures" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="category = 'Dispute Resolution'">
        <ion-label>Dispute Resolution</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="Dispute Resolution" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>

    <h6 class="ion-text-left ion-padding-start">Severity</h6>
    <ion-radio-group mode="md" [(ngModel)]="severity">
      <ion-item mode="ios" (click)="severity = ''">
        <ion-label>All severities</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="severity = 'sev1'">
        <ion-label>SEV1</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="sev1" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="severity = 'sev2'">
        <ion-label>SEV2</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="sev2" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="severity = 'sev3'">
        <ion-label>SEV3</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="sev3" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>

<ion-footer mode="ios">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
      <ion-col sizeXl="7" sizeLg="7" sizeMd="10" sizeSm="12" sizeXs="12">
        <ion-row>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="applyFilters()">Apply</ion-button>
          </ion-col>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="clearFilters()">Clear</ion-button>
          </ion-col>
        </ion-row>
        <br />
      </ion-col>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
